/*
Notes:信贷业务ajax Api
Date:2018/9/5 by hgwn
*/

import ajax from './ajax'; //引用二次封装ajax.js
export default {
    getSetting:function(){ //查询规系统设置-设置信
        return ajax.get('loanform/base/loanBaseProductCategory/getCategoryList.ht');
    }
};



// WEBPACK FOOTER //
// ./src/api/index.js